import { ErrorToast } from "../components/toastify";
import { AxiosPostMethod } from "../helpers/customAxios";
import HandleLogout from "./handleLogout";

const HandleAddOperator = async (body) => {
  const AddRes = await AxiosPostMethod("org/add/operator", body);
  if (AddRes.status === 200) {
    return true;
  }

  if (AddRes.status === 401) {
    HandleLogout();
    return null;
  }

  const errorMessage = AddRes?.data?.message || AddRes?.data?.error || "Can't add operator";
  ErrorToast(errorMessage);
  return null;
};

export default HandleAddOperator;
